import { memo, useMemo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/types';

import { FilePreviewIcon } from '~/components/v2/components/shared/file/FilePreviewIcon';
import { FILE_PREVIEW_EXTENSION_MAP, FILE_PREVIEW_MAP } from '~/components/v2/constants/filePreview';
import { isValidFilePreviewExtension } from '~/components/v2/utils/files/isValidFilePreviewExtension';

export type GalleryFilePreviewIconProps = {
  file: Clip | PublicClip;
};

export const GalleryFilePreviewIcon = memo(({ file }: GalleryFilePreviewIconProps) => {
  const { color, icon: Icon } = useMemo(() => {
    if (isValidFilePreviewExtension(file.ext)) {
      return FILE_PREVIEW_EXTENSION_MAP[file.ext];
    }

    return FILE_PREVIEW_MAP.default;
  }, [file.ext]);

  return (
    <FilePreviewIcon
      style={{
        backgroundColor: color.backgroundColor,
        color: color.textColor,
      }}
    >
      <Icon className="size-6" />
    </FilePreviewIcon>
  );
});

GalleryFilePreviewIcon.displayName = 'GalleryFilePreviewIcon';
